module.exports = __webpack_public_path__ + "static/media/cocoARApp_t.c6dc8b7a.svg";